import { render, staticRenderFns } from "./FeedAdd.vue?vue&type=template&id=bf15746a&scoped=true&"
import script from "./FeedAdd.vue?vue&type=script&lang=js&"
export * from "./FeedAdd.vue?vue&type=script&lang=js&"
import style0 from "./FeedAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf15746a",
  null
  
)

export default component.exports